import ApiService from "services/ApiService";

export const updateTestCase = async ({ id, name }) => {
    const endpoint = `/test-case/rename/${id}`;
    return await ApiService.post(endpoint, { data: { name } });
};
